import styled, { css, keyframes } from 'styled-components';
import gettext from '@sdk/lang/gettext';

import { DATE_BUBBLE_HEIGHT } from '@web/components/DateBubble/dateBubble.consts';

export const NewMessagesSeparator = styled.div`
  ${({ theme }) => css`
    --color: ${theme.colors.primary};
  `};

  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  height: ${DATE_BUBBLE_HEIGHT}px;
  position: absolute;
  top: calc(50% - ${DATE_BUBBLE_HEIGHT / 2}px);
  width: 100%;

  &::before {
    color: var(--color);
    content: '${gettext('new')}';
    font-size: 12px;
    font-weight: 600;
    padding: 0 5px;
    text-transform: uppercase;
  }

  &::after {
    background-color: var(--color);
    content: '';
    display: block;
    flex: 1;
    height: 1px;
  }
`;

type ItemWrapperProps = {
  extraSpacing?: boolean;
  highlight?: boolean;
};

const bgHighlight = keyframes`
  0% {
    background-color: transparent;
  }
  10% {
    background-color: var(--bgColor);
  }
  90% {
    background-color: var(--bgColor);
  }
  100% {
    background-color: transparent;
  }
`;

// @INFO consider content-visibility here for optimization purpose
export const ItemWrapper = styled.div<ItemWrapperProps>`
  ${({ extraSpacing, highlight, theme }) => css`
    --animation: ${highlight
      ? css`
          ${bgHighlight} 3s ease 0.5s
        `
      : 'none'};
    --bgColor: ${theme.colors.hoverBrand};
    --margin: ${extraSpacing ? '10px 0' : 'unset'};
  `};

  animation: var(--animation);
  margin: var(--margin);
  min-height: ${DATE_BUBBLE_HEIGHT}px;
  position: relative;
`;

export const DummyAnchor = styled.div``;
